<template>
  <FormFilter
    v-model="modelFilterFormData"
    @request="onSubmit"
    @reset="onReset"
  >
    <VSelect
      label="Стройка"
      name="building"
      :items="buildingList"
      :handler-search="GETBuildingList"
      search
    />

    <VSelect
      label="Статус"
      name="status"
      :items="statusObjectList"
      :handler-search="GETStatusObjectList"
      search
    />

    <VInput
      label="Наименование объекта"
      name="name"
    />

    <VSelect
      label="Кто изменил"
      name="updated_by"
      :items="userList"
      :handler-search="GETUserList"
      search
    />

    <VSelect
      label="Ответственный сметный"
      name="estimate_responsible"
      :items="userList"
      :handler-search="GETUserList"
      search
    />

    <VSelect
      label="Генподрядчик"
      name="general_contractor"
      item-text="long_name"
      :items="partnerList"
      :handlerSearch="GETPartnerList"
      search
    />

    <VSelect
      label="Договор"
      name="treaty"
      item-text="treaty_number"
      :items="contractsList"
      :handlerSearch="GETContractsList"
      search
    />

    <VInput
      label="Г/П к вычету %"
      name="deduction"
    />

    <VSelect
      label="Заказчик"
      name="customer"
      item-text="long_name"
      :items="partnerList"
      :handlerSearch="GETPartnerList"
      search
    />

    <AppInputDate
      title="Дата начала"
      name="start_date"
      type="single"
    />

    <AppInputDate
      title="Дата окончания"
      name="stop_date"
      type="single"
    />

    <VInput
      label="Стоимость"
      name="price"
    />

    <VInput
      label="Подписано"
      name="signed"
    />

    <VInput
      label="Остаток"
      name="remains"
    />

    <VCheckbox
      title="Субподрядчик Интекс"
      name="is_intex"
      class="form__checkbox-wrap"
    />
  </FormFilter>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import FormFilter from '@/components/page/Form/FormFilter/FormFilter'
import VCheckbox from '@/components/page/Form/VCheckbox/VCheckbox'
import VInput from '@/components/page/Form/Vinput/Vinput'
import VSelect from '@/components/page/Form/VSelect'

import { MIXIN_FORM_FILTER } from '@/mixins/form/mixinFormFilter'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'
import { mixinPtoObjectSelect } from '@/mixins/module/pto/mixinPtoObjectSelect'
import { createModelFilterFormData } from '@/mixins/form/createModelFilterFormData'
import { prepareFormDataId } from '@/utils/form/prepareFormDataId'
import { prepareObjectFormData } from '@/utils/page/pto/object'

export default {
  name: 'FilterPtoObject',
  components: {
    AppInputDate,
    FormFilter,
    VCheckbox,
    VInput,
    VSelect
  },
  mixins: [MIXIN_FORM_FILTER, MIXIN_USER_LIST, mixinPtoObjectSelect],

  computed: {
    ...createModelFilterFormData('pto/object')
  },
  methods: {
    onSubmit (data) {
      const prepared = prepareFormDataId(data, ['updated_by'])
      this.$emit('request', prepareObjectFormData(prepared))
    }
  }
}
</script>
